// extracted by mini-css-extract-plugin
module.exports = {"NewDomainPageContent":"NewDomain_NewDomainPageContent__1z246","Toast":"NewDomain_Toast__2Bmzs","Toast_content":"NewDomain_Toast_content__3AFfY"};